import * as React from 'react'
import './ReportsFiltering.scss'
import { Elements } from '@tfo/common'
import classnames from 'classnames'
import { ReportState } from '../../ReportsEnums'
import { ReportsFilteringListProps } from './ReportsFiltering'
import { useHistory } from 'react-router-dom'

const { Label } = Elements

const ReportsFilteringMenu: React.FunctionComponent<ReportsFilteringListProps> = props => {
	const {
		setFilterCallback,
		doneTitle,
		ongoingTitle,
		awaitingTitle,
		archivedTitle,
		activeStateFilter,
	} = props
	const isTest:boolean = ((window as any).tfoEnv === "test-" ||  window.location.hostname === 'localhost' )
	const history = useHistory()
	return (
		<div className="ReportsFiltering ReportsFilteringMenu">
			<Label
				className={classnames('ReportsFiltering__Item', {
					'ReportsFiltering__Item--active':
						activeStateFilter === ReportState.Done,
				})}
				onClick={() => setFilterCallback(ReportState.Done)}
				data-cy="done-orders">
				{doneTitle}
			</Label>
			<Label
				className={classnames('ReportsFiltering__Item', {
					'ReportsFiltering__Item--active':
						activeStateFilter === ReportState.Ongoing,
				})}
				onClick={() => setFilterCallback(ReportState.Ongoing)}
				data-cy="ongoing-orders">
				{ongoingTitle}
			</Label>
			<Label
				className={classnames('ReportsFiltering__Item', {
					'ReportsFiltering__Item--active':
						activeStateFilter === ReportState.AwaitingApproval,
				})}
				onClick={() => setFilterCallback(ReportState.AwaitingApproval)}
				data-cy="awaitingApproval-orders">
				{awaitingTitle}
			</Label>
		</div>
	)
}

export default ReportsFilteringMenu
